// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1FMYl","header":"PatientQuestionnaire_header___XPhq","info":"PatientQuestionnaire_info__3BBu7"};